// Tiny GA4 event tracker. The gtag tag is loaded in /public/index.html, so
// `window.gtag` is global. This helper guards against missing gtag (e.g. ad
// blockers, SSR) and centralises event names so they're easy to grep.
//
// Usage:
//   import { trackEvent } from '../utils/analytics';
//   trackEvent('cta_click', { cta: 'start_free_trial', location: 'home_hero' });

const RECENT = new Map(); // de-dupe within 1s window

export function trackEvent(name, params = {}) {
  if (typeof window === 'undefined') return;
  const key = `${name}::${JSON.stringify(params)}`;
  const now = Date.now();
  if (RECENT.get(key) && now - RECENT.get(key) < 1000) return;
  RECENT.set(key, now);
  try {
    if (typeof window.gtag === 'function') {
      window.gtag('event', name, params);
    }
    // Also push to dataLayer so GTM debug surfaces it consistently
    if (Array.isArray(window.dataLayer)) {
      window.dataLayer.push({ event: name, ...params });
    }
  } catch (_e) {
    /* swallow — analytics must never break UX */
  }
}

// Standardised event-name constants — keep grep-able + matches GA UI
export const EVT = {
  CTA_CLICK:                'cta_click',
  HOMEPAGE_CTA_CLICK:       'homepage_cta_click',
  SIGNUP_START:             'signup_start',
  SIGNUP_SUBMIT:            'signup_submit',
  SIGNUP_COMPLETE:          'signup_complete',
  LESSON_STARTED:           'lesson_started',
  LESSON_COMPLETED:         'lesson_completed',
  FREE_LESSON_START:        'free_lesson_start',
  FREE_LESSON_ANSWER:       'free_lesson_answer',
  FREE_LESSON_COMPLETE:     'free_lesson_complete',
  FREE_LESSON_GATE:         'free_lesson_signup_gate_view',
  PENDING_VERIFICATION_VIEW:'pending_verification_view',
  VERIFICATION_RESEND_CLICK:'verification_resend_click',
  EMAIL_VERIFIED:           'email_verified',
  WELCOME_VIEW:             'welcome_view',
  WELCOME_SUBJECT_SELECTED: 'welcome_subject_selected',
  FIRST_LESSON_OPENED:      'first_lesson_opened',
  FIRST_QUESTION_ANSWERED:  'first_question_answered',
  DASHBOARD_VIEW:           'dashboard_view',
  UPGRADE_VIEW:             'upgrade_view',
  CHECKOUT_STARTED:         'checkout_started',
  PURCHASE:                 'purchase',
};
